var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21634 18.0266C0.999839 18.0266 0.0136719 17.0404 0.0136719 15.8239C0.0136719 14.6074 0.999839 13.6213 2.21634 13.6213C3.43284 13.6213 4.41901 14.6074 4.41901 15.8239C4.41901 17.0404 3.43284 18.0266 2.21634 18.0266ZM2.21634 11.4186C0.999839 11.4186 0.0136719 10.4324 0.0136719 9.21594C0.0136719 7.99944 0.999839 7.01327 2.21634 7.01327C3.43284 7.01327 4.41901 7.99944 4.41901 9.21594C4.41901 9.80012 4.18694 10.3604 3.77386 10.7735C3.36078 11.1865 2.80052 11.4186 2.21634 11.4186ZM2.21634 4.81061C0.999839 4.81061 0.0136719 3.82444 0.0136719 2.60794C0.0136719 1.39144 0.999839 0.405273 2.21634 0.405273C3.43284 0.405273 4.41901 1.39144 4.41901 2.60794C4.41901 3.19212 4.18694 3.75238 3.77386 4.16546C3.36078 4.57854 2.80052 4.81061 2.21634 4.81061Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuThreeDots);
export default __webpack_public_path__ + "static/media/menu-three-dots.febf0f39e4afaa8e49dfe6b6d3a04b62.svg";
export { ForwardRef as ReactComponent };